export default "__VITE_ASSET__BHQRkTAQ__"